module.exports = __webpack_public_path__ + "img/industry_border.09f91914.png";